import { Component, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormHeaderComponent } from '@tuain/ng-forms';
import { AppActionComponent } from '@components/actions/app-action/app-action.component';
import { NotificationsBellComponent } from '@layout/common/notifications-bell/notifications-bell.component';
import { tuainFormsBaseModules, tuainBaseComponents } from '@components/tuain.modules';
import { EventManagerService } from '@services/event-manager.service';
import { toTitleCaseName } from '@shared/utils/name-format.util';
import { defaultConfig } from 'src/app/app.config';

const { sessionEstablished } = defaultConfig.appEvents;
@Component({
  standalone: true,
  selector: 'app-form-header',
  imports: [...tuainFormsBaseModules, ...tuainBaseComponents, AppActionComponent, NotificationsBellComponent],
  templateUrl: './app-form-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./app-form-header.component.less'],
})
export class AppFormHeaderComponent extends FormHeaderComponent implements OnInit {
  private _eventManager = inject(EventManagerService);

  @Input() showTitle = true;
  description = '';
  lastLogin = '';

  constructor() {
    super();
  }

  ngOnInit() {
    this._eventManager.subscribe(sessionEstablished.name, data => {
      const sessionData: any = data?.sessionData ?? {};
      const { name = '', primerApellido = '', sexo = 'M', lastLogin = '' } = sessionData;
      this.description = `Hola, ${name} ${primerApellido}, Bienvenid${sexo === 'M' ? 'o' : 'a'} al FNA`;
      this.lastLogin = lastLogin;
    });
  }
}
